module.exports = __webpack_public_path__ + "static/scale-model-of-red-rocks-colorado-in-lakewood-colorado-a88b879e62bff425a510bd81a1cc8070.png";